import { render, staticRenderFns } from "./PropertyGroupNavigation.vue?vue&type=template&id=7fd4da60&lang=pug&"
import script from "./PropertyGroupNavigation.vue?vue&type=script&lang=ts&"
export * from "./PropertyGroupNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports